<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.88867 6.99956L6.29451 8.41122L9.11201 5.58789"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.27117 1.43C6.67367 1.08583 7.33284 1.08583 7.74117 1.43L8.66284 2.22333C8.83784 2.375
      9.16451 2.4975 9.39784 2.4975H10.3895C11.0078 2.4975 11.5153 3.005 11.5153
      3.62333V4.615C11.5153 4.8425 11.6378 5.175 11.7895 5.35L12.5828 6.27167C12.927 6.67417 12.927
      7.33333 12.5828 7.74167L11.7895 8.66333C11.6378 8.83833 11.5153 9.165 11.5153
      9.39833V10.39C11.5153 11.0083 11.0078 11.5158 10.3895 11.5158H9.39784C9.17034 11.5158 8.83784
      11.6383 8.66284 11.79L7.74117 12.5833C7.33867 12.9275 6.6795 12.9275 6.27117 12.5833L5.34951
      11.79C5.17451 11.6383 4.84784 11.5158 4.6145 11.5158H3.60534C2.98701 11.5158 2.47951 11.0083
      2.47951 10.39V9.3925C2.47951 9.165 2.35701 8.83833 2.21117 8.66333L1.42367 7.73583C1.08534
      7.33333 1.08534 6.68 1.42367 6.2775L2.21117 5.35C2.35701 5.175 2.47951 4.84833 2.47951
      4.62083V3.6175C2.47951 2.99917 2.98701 2.49167 3.60534 2.49167H4.6145C4.842 2.49167 5.17451
      2.36917 5.34951 2.2175L6.27117 1.43Z"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    color: {
      type: String,
    },
  },
};
</script>
